function default_attribute () {
  return {
    id: 0,
    pid: 0,
    n: '',
    children: []
  }
}

export default default_attribute
